import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_THREATS, PAGE_OFFER, PAGE_CONTACT, PAGE_ABOUT, PAGE_ESTIMATION } from '../../config/pages';
// import { LANG_PL, LANG_EN } from '../../config/languages';

import Link from '../helpers/Link';

const HeaderMenu = ({
    t, openPage, language, page, closeMenu
}) =>
    // TODO
    // 04.12.2023 the scanner link was hidden for testing it *
    // const blogLanguage = (language === LANG_PL || language === LANG_EN) ? `${ language }/` : '';
    (
        <ul className="header-menu-main" id="header-menu-main">
            {/*  // TODO
            // 04.12.2023 the scanner link was hidden for testing it */}
            {/* {
                language === 'de' ? (
                    <li id="menu-item-8">
                        <a href="https://scanner.lemlock.com/en" className="link">Scanner</a>
                    </li>
                ) : (
                    <li id="menu-item-8">
                        <a href={ `https://scanner.lemlock.com/${ blogLanguage }` } className="link">{ t('header.menu.scanner') }</a>
                    </li>
                )
            } */}
            <li className={ cx({ active: (page === PAGE_THREATS) }) } id="menu-item-1">
                <Link
                  openPage={ openPage }
                  language={ language }
                  page={ PAGE_THREATS }
                  callback={ closeMenu }
                  id="menu-link-threats"
                  className="link"
                >
                    { t('header.menu.threats') }
                </Link>
            </li>
            <li className={ cx({ active: (page === PAGE_OFFER) }) } id="menu-item-2">
                <Link
                  openPage={ openPage }
                  language={ language }
                  page={ PAGE_OFFER }
                  callback={ closeMenu }
                  id="menu-link-offer"
                  className="link"
                >{ t('header.menu.offer') }
                </Link>
            </li>
            <li className={ cx({ active: (page === PAGE_ESTIMATION) }) } id="menu-item-7">
                <Link
                  openPage={ openPage }
                  language={ language }
                  page={ PAGE_ESTIMATION }
                  callback={ closeMenu }
                  id="menu-link-estimation"
                  className="link"
                >
                    { t('header.menu.estimation') }
                </Link>
            </li>
            <li className={ cx({ active: (page === PAGE_ABOUT) }) } id="menu-item-6">
                <Link
                  openPage={ openPage }
                  language={ language }
                  page={ PAGE_ABOUT }
                  callback={ closeMenu }
                  id="menu-link-about"
                  className="link"
                >
                    { t('header.menu.about') }
                </Link>
            </li>
            <li className={ cx({ active: (page === PAGE_CONTACT) }) } id="menu-item-5">
                <Link
                  openPage={ openPage }
                  language={ language }
                  page={ PAGE_CONTACT }
                  callback={ closeMenu }
                  id="menu-link-contact"
                  className="link"
                >
                    { t('header.menu.contact') }
                </Link>
            </li>
        </ul>
    );
HeaderMenu.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    closeMenu: PropTypes.func.isRequired
};

export default HeaderMenu;



// WEBPACK FOOTER //
// ./src/components/header/HeaderMenu.jsx